module.exports = __webpack_public_path__ + "img/IMG_3945_L_Black.550c9197.jpg";